export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let lenisInstance = null;

export const setLenis = (instance) => {
  lenisInstance = instance;
};

export const scrollToId = (selector) => {
  const el = document.querySelector(selector);
  if (!el) return;
  if (lenisInstance) {
    lenisInstance.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
